import { vuexfireMutations, firestoreAction } from "vuexfire"

const getDefaultState = () => {
	return {
		current: {},
		people: [],
	}
}

export const state = () => ({
	current: {},
	people: [],
})

export const mutations = {
	...vuexfireMutations,
	RESET_STATE(state) {
		Object.assign(state, getDefaultState())
	},
}

export const actions = {
	bind: firestoreAction(async function ({ bindFirestoreRef }, id) {
		const ref = this.$fire.firestore.collection("organisations").doc(id)
		await bindFirestoreRef("current", ref, { wait: true })
	}),
	// Prospects linked to the organisation. References are left unresolved, the list only needs flat fields
	bindPeople: firestoreAction(async function ({ bindFirestoreRef }, id) {
		const ref = this.$fire.firestore.collection("organisations").doc(id)
		const query = this.$fire.firestore.collection("prospects").where("ref_organisation", "==", ref)
		await bindFirestoreRef("people", query, { wait: true, maxRefDepth: 0 })
	}),
	unbind: firestoreAction(function ({ unbindFirestoreRef }) {
		unbindFirestoreRef("current", () => {
			return {}
		})
		unbindFirestoreRef("people", () => {
			return []
		})
	}),
	reset({ commit, dispatch }) {
		dispatch("unbind")
		commit("RESET_STATE")
	},
}

export const getters = {
	getCurrent(state) {
		return state.current
	},
	getPeople(state) {
		return state.people
	},
}
